import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import Form from '@piconetworks/pkg-form';
import { H3 } from '@piconetworks/pkg-heading';
import { P } from '@piconetworks/pkg-text';
import { format } from '@piconetworks/pkg-currency';
import { AnnualPercentDiscount } from '@piconetworks/pkg-functions';
import style from './scss/SelectTrial.module.scss.js';
import { RemoteJsonText } from '@piconetworks/pkg-remote-markdown';
import { selectors } from '@piconetworks/pkg-module-loader';

var _excluded = ["fieldContainerProps", "required", "popup", "name", "linkColor", "contrastColor", "isGift", "product", "className", "giftCta", "customFeaturesUrl", "currentProductOptionId", "trialIneligible"];
var SelectTrial = function SelectTrial(props) {
  var _product$options, _classNames, _classNames2;
  var fieldContainerProps = props.fieldContainerProps,
    required = props.required;
    props.popup;
    var name = props.name,
    _props$linkColor = props.linkColor,
    linkColor = _props$linkColor === void 0 ? '' : _props$linkColor,
    _props$contrastColor = props.contrastColor,
    contrastColor = _props$contrastColor === void 0 ? '' : _props$contrastColor,
    _props$isGift = props.isGift,
    isGift = _props$isGift === void 0 ? false : _props$isGift,
    _props$product = props.product,
    product = _props$product === void 0 ? {} : _props$product,
    className = props.className,
    _props$giftCta = props.giftCta,
    giftCta = _props$giftCta === void 0 ? function () {} : _props$giftCta,
    _props$customFeatures = props.customFeaturesUrl,
    customFeaturesUrl = _props$customFeatures === void 0 ? '' : _props$customFeatures,
    currentProductOptionId = props.currentProductOptionId,
    trialIneligible = props.trialIneligible,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _selectors = selectors();
    _selectors.priceText;
  var pluralizedTrialInterval = function pluralizedTrialInterval(trialInterval, trialQuantity) {
    return "" + trialInterval + (trialQuantity === 0 || trialQuantity > 1 ? 's' : '');
  };
  var title = product === null || product === void 0 ? void 0 : product.title;
  var defaultIsAnnualChecked = true;
  var formattedOptions = (product === null || product === void 0 ? void 0 : (_product$options = product.options) === null || _product$options === void 0 ? void 0 : _product$options.reduce(function (selections, _ref) {
    var value = _ref.id,
      interval = _ref.interval,
      amount = _ref.price,
      trialQuantity = _ref.trial_quantity,
      trialInterval = _ref.trial_interval,
      trialAmount = _ref.trial_price,
      currencyCode = _ref.currency,
      defaultOption = _ref.default_option;
    var alreadySubscribed = currentProductOptionId === value;
    var price = format({
      currencyCode: currencyCode,
      amount: amount,
      symbol: true
    });
    var trialPrice = format({
      currencyCode: currencyCode,
      amount: trialAmount,
      symbol: true
    });
    var text = isGift ? "Gift The first " + interval : alreadySubscribed ? 'Already subscribed' : trialIneligible ? "1 " + pluralizedTrialInterval(interval, 1) + " for " + price : !trialAmount && !!trialInterval ? "Try " + trialQuantity + " " + pluralizedTrialInterval(trialInterval, trialQuantity) + " for Free" : "Try " + trialQuantity + " " + pluralizedTrialInterval(trialInterval, trialQuantity) + " for " + trialPrice;
    selections[interval] = {
      value: value,
      text: text,
      price: price,
      amount: amount,
      interval: interval,
      trialPrice: trialPrice,
      trialAmount: trialAmount,
      trialQuantity: trialQuantity,
      trialInterval: trialInterval
    };
    if (interval === 'month' && defaultOption) {
      defaultIsAnnualChecked = false;
    }
    return selections;
  }, {})) || [];
  var _useState = useState(defaultIsAnnualChecked),
    isAnnualChecked = _useState[0],
    toggleAnnualChecked = _useState[1];
  var showPlanIntervalSwitch = Object.keys(formattedOptions).length > 1;
  var selectedPlan = showPlanIntervalSwitch ? isAnnualChecked ? formattedOptions.year : formattedOptions.month : formattedOptions[Object.keys(formattedOptions)[0]];
  var text = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.text;
  var value = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.value;
  var alreadySubscribed = currentProductOptionId === value;
  var price = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.price;
  var trialPrice = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.trialPrice;
  var trialAmount = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.trialAmount;
  var trialQuantity = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.trialQuantity;
  var trialInterval = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.trialInterval;
  var interval = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.interval;
  var savings;
  if (showPlanIntervalSwitch) {
    var _formattedOptions$mon, _formattedOptions$yea;
    var monthlyPrice = formattedOptions === null || formattedOptions === void 0 ? void 0 : (_formattedOptions$mon = formattedOptions.month) === null || _formattedOptions$mon === void 0 ? void 0 : _formattedOptions$mon.amount;
    var annualPrice = formattedOptions === null || formattedOptions === void 0 ? void 0 : (_formattedOptions$yea = formattedOptions.year) === null || _formattedOptions$yea === void 0 ? void 0 : _formattedOptions$yea.amount;
    savings = annualPrice < monthlyPrice * 12 && AnnualPercentDiscount(monthlyPrice, annualPrice);
  }
  return /*#__PURE__*/React.createElement(Form.Field, fieldContainerProps, /*#__PURE__*/React.createElement("div", {
    className: classNames(style.container, className)
  }, title && /*#__PURE__*/React.createElement("div", {
    className: style.header
  }, /*#__PURE__*/React.createElement(H3, {
    className: style.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: style.priceContainer
  }, !trialIneligible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(H3, {
    className: style.price
  }, !trialAmount ? 'Free' : trialPrice), /*#__PURE__*/React.createElement("small", null, "for ", trialQuantity, " ", pluralizedTrialInterval(trialInterval, trialQuantity)), /*#__PURE__*/React.createElement("small", {
    className: style.then
  }, "then")), /*#__PURE__*/React.createElement(H3, {
    className: style.price
  }, price), /*#__PURE__*/React.createElement("small", null, "per ", interval))), /*#__PURE__*/React.createElement("div", {
    className: style.dflex
  }, /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", {
    className: style.features
  }, customFeaturesUrl && /*#__PURE__*/React.createElement(RemoteJsonText, {
    url: customFeaturesUrl,
    style: style,
    linkColor: linkColor
  })), showPlanIntervalSwitch && /*#__PURE__*/React.createElement("div", {
    className: style.radios
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return toggleAnnualChecked(false);
    },
    className: classNames(style.tab, (_classNames = {}, _classNames[style.checked] = interval === 'month', _classNames))
  }, /*#__PURE__*/React.createElement("p", null, "Monthly")), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return toggleAnnualChecked(true);
    },
    className: classNames(style.tab, (_classNames2 = {}, _classNames2[style.checked] = interval === 'year', _classNames2))
  }, /*#__PURE__*/React.createElement("p", null, " ", "Annual" + (savings ? " (Save " + savings + "%)" : ''))))), /*#__PURE__*/React.createElement("div", {
    className: style.col6
  }, /*#__PURE__*/React.createElement("div", {
    className: style.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: style.buttons
  }, !isGift && /*#__PURE__*/React.createElement(P, {
    className: classNames(style['link-text'], style.gift),
    onClick: function onClick() {
      return giftCta(value);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-icon_gift"
  }), /*#__PURE__*/React.createElement("span", null, "Gift")), /*#__PURE__*/React.createElement(Field, _extends({}, required && {
    validate: function validate(value) {
      return value ? undefined : 'Required';
    }
  }, {
    name: name,
    render: function render(props) {
      return /*#__PURE__*/React.createElement(Form.Radio, _extends({}, props, {
        disabled: alreadySubscribed,
        className: classNames('btn', style.btn, style.hidden),
        style: {
          color: contrastColor
        },
        fieldProps: {
          className: classNames('btn', style.btn, alreadySubscribed && style.disabled)
        }
      }));
    },
    text: text,
    value: value,
    type: "radio"
  }, rest))))))));
};

export { SelectTrial as default };
//# sourceMappingURL=index.js.map
